import { me } from 'api/auth'
import { API_CALL_SUCCESS } from 'actions/actionConstants'
import { USER_LOGIN } from 'actions/apiActionConstants'
import type { AppAction } from 'actions/types/ActionTypes'
import { getIsLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'
import { setMonitoringUser } from 'services/userMonitoring'
import { ensureValidOidcSession } from './ensureValidOidcSession'
import { markOidcSession } from './authMethod'

// Bootstrap recovery for a v2 session SSR rendered anonymous because the access
// token expired: refresh, validate with /me, dispatch USER_LOGIN. The refresh
// mirrors the token to the cookie before /me confirms it; the coordinator clears
// the cookie if /me rejects, so SSR stays self-consistent.
export function recoverOidcSession(): AppAction {
  return async(dispatch, getState) => {
    const state = getState()
    const regionCode = state.geo.currentRegionCode
    const luxPlusEnabled = getIsLuxPlusEnabled(state)

    const accessToken = await ensureValidOidcSession()
    if (!accessToken) {
      throw new Error('OIDC silent sign-in returned no access token')
    }

    const account = await me(accessToken, regionCode, luxPlusEnabled)
    // initialiseUser defers the OIDC path, so attribute error monitoring here.
    setMonitoringUser(account.memberId)
    markOidcSession()

    dispatch({
      type: API_CALL_SUCCESS,
      api: USER_LOGIN,
      source: 'email',
      // isSignIn false: a restore is a rehydration, so post-login side effects
      // (signin analytics, the earn-your-own-tour promo) must not fire.
      data: {
        account,
        accessToken,
        isSignIn: false,
        authMethod: 'oidc',
      },
    })
  }
}
